import {
  Checkbox,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemText,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Loading from "../../loading";
import Snackbar from "../../snackbar";
import { styles } from "./styles";

class ListMenuGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "name",
      selected: [],
      message: "",
      id: 1,
      collapse: [],
      checked: [0],
    };
  }
  handleRequestSort = () => {
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order });
  };

  handleSelectAllClick = (checked) => {
    let selected = [];
    if (checked) {
      selected = this.props.allListMenu.map((item) => item.id);
    }
    this.setState(
      {
        selected: selected,
      },
      function () {
        this.props.setMenuId(selected);
        this.props.getListItem({ id: selected }); // send id to index => fetch list item menu
      }
    );
  };
  async componentDidMount() {
    this.props.onRef(this);
    this.getMenuGroup();
    await this.props.getAllList();

    this.handleSelectAllClick(true);
  }

  async componentWillReceiveProps(nextProps) {
    if (this.props.allMenuItem !== nextProps.allMenuItem) {
      this.setState({ allMenuItem: nextProps.allMenuItem });
    }
    if (this.props.menuId !== nextProps.menuId) {
      this.setState({ id: nextProps.menuId });
    }
    if (
      nextProps.adminService !== this.props.adminService ||
      (nextProps.adminService &&
        this.props.adminService &&
        nextProps.adminService.no !== this.props.adminService.no)
    ) {
      this.getMenuGroup({ serviceCode: nextProps.adminService.no });
      await this.props.getAllList();
      this.handleSelectAllClick(true);
    }
  }

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy)
      : (a, b) => -this.desc(a, b, orderBy);
  }

  desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  handleOpenCollapes(id) {
    const collapse = this.state.collapse;
    if (collapse.indexOf(id) !== -1) collapse.splice(collapse.indexOf(id), 1);
    else collapse.push(id);
    this.setState(collapse);
  }

  isExist = (newSelected, x) => newSelected.indexOf(x) > -1;

  handleClick = (item) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(item.id);
    let subMenu = [];
    let newSelected = [];
    if (selectedIndex === -1) {
      subMenu = subMenu.concat(selected, item.id, this.getIdSubMenu(item));
      subMenu.forEach((element) => {
        if (!this.isExist(newSelected, element)) newSelected.push(element);
      });
    } else {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
      subMenu = this.getIdSubMenu(item);
      subMenu.forEach((element) => {
        if (newSelected.indexOf(element) !== -1) {
          newSelected = newSelected
            .slice(0, newSelected.indexOf(element))
            .concat(newSelected.slice(newSelected.indexOf(element) + 1));
        }
      });
    }
    this.setState({ selected: newSelected });

    this.props.setMenuId(newSelected);
    this.props.getListItem({ id: newSelected });
  };
  getIdSubMenu = (item) => {
    let newSelected = [];
    if (item.subMenu.isFulfilled && item.subMenu.fulfillmentValue.length > 0) {
      item.subMenu.fulfillmentValue.forEach((element) => {
        newSelected = newSelected.concat(element.id);
        newSelected = newSelected.concat(this.getIdSubMenu(element));
      });
    }
    return newSelected;
  };
  checkSelected = (item) => {
    const { selected } = this.state;
    if (!item.subMenu.isFulfilled && selected.indexOf(item.id) !== -1)
      return true;
    else if (!item.subMenu.isFulfilled && selected.indexOf(item.id) == -1)
      return false;
    let check = item.subMenu.fulfillmentValue.map((item, index) => {
      return selected.indexOf(item.id) != -1 && this.checkSelected(item);
    });
    return check.indexOf(false) == -1 && selected.indexOf(item.id) != -1;
  };

  toggleFeatured = async (menuItem = {}) => {
    const { t } = this.props;
    menuItem.featured = !menuItem.featured
    let check = await this.props.editMenuGroup(
      { ...menuItem }
    );
    if (check && check.code === 1) {
      this.getMenuGroup();
      if (menuItem.featured)
        this.mSnackbar.handleClick(
          t("menu_menuitem_remove_item_featured_successfully")
        );
      else
        this.mSnackbar.handleClick(
          t("menu_menuitem_add_item_featured_successfully")
        );
    } else {
      if (menuItem.featured)
        this.mSnackbar.handleClick(
          t("menu_menuitem_remove_item_featured_unsuccessfully") +
          " " +
          check.message,
          "error"
        );
      else
        this.mSnackbar.handleClick(
          t("menu_menuitem_add_item_featured_unsuccessfully") +
          " " +
          check.message,
          "error"
        );
    }
  };
  renderMenuItem = (item, menuLevel) => {
    const { classes, disabled = false } = this.props;
    const { selected, collapse } = this.state;
    const isSelected = selected.indexOf(item.id) >= 0 ? true : false;
    return [
      <ListItem
        style={{ cursor: "pointer", paddingLeft: `${menuLevel * 16}px` }}
        key={`menu-${item.id}`}
        role={undefined}
        divider={true}
      >
        <Checkbox
          onClick={() => this.handleClick(item)}
          checked={isSelected}
          tabIndex={-1}
          disableRipple
        />
        <ListItemText
          dense="true"
          primary={`${item.name}`}
          className={classes.menuName}
          className={classes.limit}
          onClick={() => this.handleOpenCollapes(item.id)}
        />
        <ListItemSecondaryAction>
          <Checkbox
            checked={item.featured ? true : false}
            onChange={() => this.toggleFeatured(item)}
            value="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
          {!disabled && (
            <IconButton
              onClick={(event) => this.props.handleEditMenuGroup(item, "edit")}
            >
              <img className={classes.iconEdit} src="/images/icon/pencil.svg" />
            </IconButton>
          )}
          {item.subMenu &&
            item.subMenu.isFulfilled &&
            item.subMenu.fulfillmentValue.length ? (
            <IconButton onClick={() => this.handleOpenCollapes(item.id)}>
              {collapse.indexOf(item.id) != -1 ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </IconButton>
          ) : (
            ""
          )}
        </ListItemSecondaryAction>
      </ListItem>,
      <Collapse
        in={collapse.indexOf(item.id) != -1}
        key={`collapse-${item.id}`}
      >
        {item.subMenu.isFulfilled &&
          item.subMenu.fulfillmentValue.length > 0 &&
          item.subMenu.fulfillmentValue.map((item) => {
            return this.renderMenuItem(item, menuLevel + 1);
          })}
      </Collapse>,
    ];
  };
  getMenuGroup = async (payload = {}) => {
    let { t, adminService = {}, role = "" } = this.props;
    if (
      (role !== "admin" && role !== "employeeAdmin") ||
      (adminService && adminService.no) ||
      payload.serviceCode
    ) {
      if (!payload.serviceCode) {
        payload.serviceCode = adminService.no;
      }
      this.loading.startLoading();
      let check = await this.props.getMenuGroup({
        ...payload,
      });
      this.loading.stopLoading();
      if (check.code === 1 && !check.data.length) {
        return [];
      } else if (check.code !== 1) {
        this.mSnackbar.handleClick(check.message, "error");
        return [];
      }
      return check.data;
    }
  };

  render() {
    const { classes, t, allListMenu, listMenu } = this.props;
    const { selected = [], order, orderBy } = this.state;
    const rowCount = allListMenu.length;
    const numSelected = selected.length;

    return (
      <div>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Toolbar className={classes.rootTitle}>
          <Typography variant="h6" id="tableTitle">
            {t("menu_menugroup_name")}
          </Typography>
        </Toolbar>
        <List className={classes.root}>
          <ListItem key={`menu-title`} role={undefined} divider>
            <Checkbox
              disableRipple
              tabIndex={-1}
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={() =>
                this.handleSelectAllClick(
                  numSelected === rowCount ? false : true
                )
              }
            />
            <ListItemText
              onClick={this.handleRequestSort}
              primary={
                <Typography variant="body2" className={classes.subTitle}>
                  <Tooltip
                    title="Sort"
                    placement={"bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={true}
                      direction={order}
                      onClick={this.handleRequestSort}
                    >
                      {t("name")}
                    </TableSortLabel>
                  </Tooltip>
                </Typography>
              }
              className={classes.menuName}
            />
            <ListItemText
              dense="true"
              primary={t("menu_menuitem_tablehead_featured")}
              className={classes.menuName}
            />
          </ListItem>
          {listMenu.sort(this.getSorting(order, orderBy)).map((row, index) => {
            return this.renderMenuItem(row, 1);
          })}
        </List>
      </div>
    );
  }
}

ListMenuGroup.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService || {},
  role: state.user.user.roleId.role,
  listMenu: state.serviceMenu.listMultiLevel,
  ownerCode: state.service.service.userCode,
  allListMenu: state.serviceMenu.listMenuGroup,
});

const mapDispatch = (dispatch) => ({
  editMenuGroup: dispatch.serviceMenu.editMenuGroup,
  getMenuGroup: dispatch.serviceMenu.getMenuGroup,
  getAllList: dispatch.serviceMenu.getAllMenuGroup,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListMenuGroup)
  )
);
